<template>
  <div>
    <div class="col-md-12 pt-0">
      <div :class="boxClass()" :style="borderStyle()" @click="goToDetailRuta()">
        <div class="col-md-1 subBoxChofer">
          <p class="mb-0">
            <b>#{{ ruta.numTrip }}</b>
          </p>
        </div>
        <div class="col-md-2 subBoxChofer">
          <p class="mb-0">
            <b>{{ ruta.nameDriver }}</b>
          </p>
          <span style="text-transform: uppercase;">{{ ruta.patent }}</span>
        </div>
        <div class="col-md-2 subBoxChofer">
          <p class="mb-0">
            <b>{{ ruta.companyTransportName }}</b>
          </p>
          <span style="text-transform: uppercase;">{{ ruta.dirOrigen }}</span>
        </div>
        <!--<div class="col-md-2 subBoxChofer">
          <b style="text-transform: capitalize;">{{ruta.name}}</b>
        </div>-->

        <div class="col-md-3">
          <div id="chart" class="float-left">
            <apexchart v-if="ruta.remitosTotales - ruta.remitosEntregados != 0" ref="Chart01" type="donut" width="90" height="90" :options="chart01Options" :series="series01" />
            <apexchart v-else ref="Chart01" type="donut" width="90" height="90" :options="chart02Options" :series="series01" />
          </div>

          <div class="ptop-10">
            <p class="mb-0">
              <b>{{ getEntregados(ruta) }}</b> {{ $t("Entregados") }}
            </p>
            <p class="mb-0">
              <b>{{ getNoEntregados(ruta) }}</b>
              {{ $t("No") + " " + $t("Entregados") }}
            </p>

            <span v-if="isEnEspera()"
              ><b>{{ getEnCamino(ruta) }} </b> {{ $t("Despachado") }}</span
            >
            <span v-else
              ><b>{{ getEnCamino(ruta) }} </b> {{ $t("En_camino") }}</span
            >
          </div>
        </div>
        <div class="col-md-4 subBoxChofer">
          <div class="row">
            <div class="col px-1">
              <div class="row">
                <!-- Hora programada -->
                <div class="col-md-4 px-1">
                  <p class="mb-0 text-center" style="font-size: 14px;"><b>Fecha estipulada</b></p>
                  <span class="d-block text-center text-caption mb-0" style="font-size: 12px;">
                    {{ ruta.date ? getFecha(new Date(ruta.date)) : "-" }}
                  </span>
                  <span class="d-block text-center text-caption mb-0" style="font-size: 12px;">
                    {{ ruta.date ? getHora(new Date(ruta.date)) : "-" }}
                  </span>
                </div>

                <!-- Hora inicio/fin de carga -->
                <div class="col-md-4 px-1">
                  <p class="mb-0 text-center" style="font-size: 14px;"><b> Carga</b></p>
                  <div class="d-flex justify-content-center align-items-center mb-0" style="font-size: 11px;">
                    <span style="min-width: 35px; text-align: right;">Inicio</span>
                    <span class="mx-1">|</span>
                    <span style="min-width: 35px; text-align: left;">Fin</span>
                  </div>
                  <div class="d-flex justify-content-center align-items-center mb-0" style="font-size: 12px;">
                    <span style="min-width: 35px; text-align: right;">{{ ruta.initialCharge != null ? getHora(new Date(ruta.initialCharge)) : "-" }}</span>
                    <span class="mx-1">|</span>
                    <span style="min-width: 35px; text-align: left;">{{ ruta.finishedCharge != null ? getHora(new Date(ruta.finishedCharge)) : "-" }}</span>
                  </div>
                </div>

                <!-- Hora inicio/fin de viaje -->
                <div class="col-md-4 px-1">
                  <p class="mb-0 text-center" style="font-size: 14px;"><b>Viaje</b></p>
                  <div class="d-flex justify-content-center align-items-center mb-0" style="font-size: 11px;">
                    <span style="min-width: 35px; text-align: right;">Inicio</span>
                    <span class="mx-1">|</span>
                    <span style="min-width: 35px; text-align: left;">Fin</span>
                  </div>
                  <div class="d-flex justify-content-center align-items-center mb-0" style="font-size: 12px;">
                    <span style="min-width: 35px; text-align: right;">{{ ruta.initialDate != null ? getHora(new Date(ruta.initialDate)) : "-" }}</span>
                    <span class="mx-1">|</span>
                    <span style="min-width: 35px; text-align: left;">{{ ruta.finishedTrip != null ? getHora(new Date(ruta.finishedTrip)) : "-" }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col px-1">
            
            </div>
            <div class="col subBoxChofer pl-0 d-flex align-items-center justify-content-center">
              <b v-if="sinRemitos()" class="state_en_espera">{{ $t("En_espera") }}</b>
              <b v-else-if="isComplete()" class="state_entregado">Completada</b>
              <b v-else-if="isEnCurso()" class="state_en_camino">{{ $t("En_curso") }}</b>
              <b v-else-if="isEnEspera()" class="state_en_espera">{{ $t("En_espera") }}</b>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { remitosService } from "@/libs/ws/remitosService";
export default {
  name: "RutaMonitoring",
  props: {
    ruta: Object,
  },
  data() {
    return {
      series01: [],
      chart02Options: {},
      chart01Options: {
        stroke: { show: false },
        colors: ["#f23d4f", "#d4d4d4"],
        legend: { show: false },
        tooltip: { enabled: false },
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            customScale: 1,
            donut: {
              size: "85%",
              labels: {
                show: true,
                name: { offsetY: -20 },
                value: {
                  fontSize: 16,
                  offsetY: -10,
                  color: "#f23d4f",
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "",
                  formatter: function(w) {
                    var result = 0;

                    if (parseInt(w.globals.series[0]) + parseInt(w.globals.series[1]) == 0) {
                      result = 0;
                    } else {
                      result = Math.trunc((w.globals.series[0] * 100) / (w.globals.series[0] + w.globals.series[1]));
                    }

                    return result + "%";
                  },
                },
              },
            },
          },
        },
      },
    };
  },
  computed: {
    rutaUpdate() {
      return this.ruta;
    },
  },
  watch: {},
  mounted() {
    var aux = Object.assign({}, this.chart01Options);
    aux.colors = ["#d4d4d4", "#d4d4d4"];
    aux.plotOptions.pie.donut.labels.value.color = "#d4d4d4";
    this.chart02Options = Object.assign({}, aux);

    this.series01 = [parseInt(this.getEntregados(this.ruta)) + parseInt(this.getNoEntregados(this.ruta)), parseInt(this.getEnCamino(this.ruta))];
  },
  methods: {
    goToDetailRuta() {
      this.$router.push("/monitoring/route/" + this.ruta.id);
    },
    isComplete() {
      //if (this.ruta.delivered.length == this.getEntregados(this.ruta)) {
      if (this.ruta.finishedTrip != null) {
        return true;
      } else {
        return false;
      }
    },
    sinRemitos() {
      if (this.ruta.remitosTotales == 0) {
        return true;
      } else {
        return false;
      }
    },
    isEnCurso() {
      if (!this.isComplete() && this.ruta.initialDate != null) {
        return true;
      } else {
        return false;
      }
    },
    isEnEspera() {
      if (!this.isComplete() && this.ruta.initialDate == null) {
        return true;
      } else {
        return false;
      }
    },
    boxClass() {
      if (this.isComplete() && this.ruta.remitosTotales != 0) {
        return "box-chofer complete row";
      } else {
        return "box-chofer enCurso row";
      }
    },
    borderStyle() {
      let color = "";

      if (this.sinRemitos()) {
        // Sin remitos - gris
        color = "#9e9e9e";
      } else if (this.isComplete()) {
        // Completada - verde
        color = "#5fba7d";
      } else if (this.isEnCurso()) {
        // En curso - azul
        color = "#7390fc";
      } else if (this.isEnEspera()) {
        // En espera - rojo
        color = "#ff5252";
      }

      return {
        "border-right": `7px solid ${color}`,
      };
    },
    getHora(date) {
      const tempMinutes = date.getMinutes();
      const minutes = tempMinutes < 10 ? `0${tempMinutes}` : tempMinutes;
      var hora = date.getHours() + ":" + minutes;
      return hora;
    },
    getFecha(date) {
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    getEntregados(ruta) {
      return ruta.remitosEntregados;
    },
    getNoEntregados(ruta) {
      return ruta.remitosNoEntregados;
    },
    getEnCamino(ruta) {
      return ruta.remitosTotales - ruta.remitosEntregados - ruta.remitosNoEntregados;
    },
  },
};
</script>
